<ion-menu side="start" menuId="first" contentId="main-content" (ionDidOpen)="onMenuOpened()">
    <ion-header>
        <ion-toolbar color="primary">
            <ion-title>Menu</ion-title>
            <ion-buttons slot="end">
                <ion-menu-toggle>
                    <ion-button (click)="closeMenu()" aria-label="Close menu">
                        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                    </ion-button>
                </ion-menu-toggle>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content>
      <!-- Flex column filling the scroll area so the version footer is pushed
           to the bottom when content is short, yet scrolls when it overflows. -->
      <div class="menu-content">
        <!-- Getting started sits first: it is the way back into the onboarding
             tours, so it has to be findable without scrolling the menu. -->
        <div class="menu-group surface">
            <ion-menu-toggle>
                <ion-item lines="none" button="true" (click)="replayOnboarding()" data-testid="menu-getting-started">
                    <ion-icon name="help-circle-outline" slot="start"></ion-icon>
                    <ion-label>{{ OnboardingMenuLabel }}</ion-label>
                </ion-item>
            </ion-menu-toggle>
            <!-- Not wrapped in ion-menu-toggle: the chooser closes the menu itself,
                 and auto-close would race the action sheet it presents. -->
            <ion-item lines="none" button="true" detail="true" (click)="openGuidedTours()" data-testid="menu-guided-tours">
                <ion-icon name="map-outline" slot="start"></ion-icon>
                <ion-label>{{ GuidedToursMenuLabel }}</ion-label>
            </ion-item>
        </div>

        <!-- Go Premium & Cloud sync -->
        @if (canShowGoPremium() || isAuthenticated()) {
            <div class="menu-group surface">
                @if (canShowGoPremium()) {
                    <ion-menu-toggle>
                        <ion-item lines="none" button="true" detail="false" (click)="goPremium()">
                            <ion-icon name="star-outline" color="warning" slot="start"></ion-icon>
                            <ion-label>Go Premium</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                }
                @if (isAuthenticated()) {
                    <ion-menu-toggle>
                        <app-sync-row></app-sync-row>
                    </ion-menu-toggle>
                }
            </div>
        }

        <!-- Progress & goals -->
        <div class="menu-group surface">
            <ion-menu-toggle>
                <ion-item lines="none" button="true" detail="true" routerLink="/progress" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-tour="menu-progress">
                    <ion-icon name="stats-chart-outline" slot="start"></ion-icon>
                    <ion-label>Progress</ion-label>
                </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle>
                <ion-item lines="none" button="true" detail="true" routerLink="/goals" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH">
                    <ion-icon name="flame-outline" slot="start"></ion-icon>
                    <ion-label>Goals &amp; streaks</ion-label>
                </ion-item>
            </ion-menu-toggle>
        </div>

        <!-- Account (signed-in) -->
        @if (isAuthenticated()) {
            <div class="menu-group surface">
                <ion-menu-toggle>
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/profile" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH">
                        <ion-icon name="person-outline" slot="start"></ion-icon>
                        <ion-label>Profile</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <!-- Personal branding. Not for a member of an organisation:
                     their brand is the org's, and the org admin edits it. -->
                <ion-menu-toggle *hasAccess="'BrandingPageComponent'">
                    <ion-item lines="none" button="true" detail="true" routerLink="/branding" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-testid="menu-branding">
                        <ion-icon name="color-palette-outline" slot="start"></ion-icon>
                        <ion-label>Pro branding</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle *hasAccess="'OrgBrandingComponent'">
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/organization-branding" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH">
                        <ion-icon name="business-outline" slot="start"></ion-icon>
                        <ion-label>Organisation branding</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <!-- Managing the organisation's members. The claim is granted to
                     ORG-ADMIN alone, so a member of an org never sees this row —
                     and neither does anyone without an organisation. -->
                <!-- What the members of this business have been doing. The
                     claim is ORG-ADMIN's alone. -->
                <ion-menu-toggle *hasAccess="'OrganizationAuditComponent'">
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/organization-audit" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-testid="menu-organization-audit">
                        <ion-icon name="time-outline" slot="start"></ion-icon>
                        <ion-label>Organisation activity</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle *hasAccess="'OrganizationUsersComponent'">
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/organization-users" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-testid="menu-organization-users">
                        <ion-icon name="people-circle-outline" slot="start"></ion-icon>
                        <ion-label>Organisation users</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle>
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/security-mfa" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH">
                        <ion-icon name="shield-checkmark-outline" slot="start"></ion-icon>
                        <ion-label>Security</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle>
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/sessions" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH">
                        <ion-icon name="phone-portrait-outline" slot="start"></ion-icon>
                        <ion-label>Devices &amp; sessions</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <!-- Buying and billing. An org member does not buy: the org
                     admin holds the plan for the whole organisation. -->
                <ion-menu-toggle *hasAccess="'OrdersComponent'">
                    <ion-item lines="none" button="true" detail="true" routerLink="/account/orders" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-testid="menu-manage-subscriptions">
                        <ion-icon name="document-text-outline" slot="start"></ion-icon>
                        <ion-label>Manage Subscriptions</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </div>
        } @else {
            <div class="menu-group surface">
                <ion-menu-toggle>
                    <ion-item lines="none" button="true" detail="true" routerLink="/login">
                        <ion-icon name="log-in-outline" slot="start"></ion-icon>
                        <ion-label>Sign in</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </div>
        }

        <!-- Library sharing -->
        <div class="menu-group surface">
            <!-- Import / Export / Manage now live on the Share page; sharing
                 requires a signed-in account (ADR-0044), so it is hidden for guests. -->
            @if (isAuthenticated()) {
                <ion-menu-toggle>
                    <ion-item lines="none" button="true" detail="true" routerLink="/share" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-tour="menu-share">
                        <ion-icon name="share-social-outline" slot="start"></ion-icon>
                        <ion-label>Share</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <!-- Publishing to the community catalog. Signed-in only, and
                     only where the server says publishing is live; the page
                     itself is empty until something has been published. -->
                @if (publishAvailable()) {
                    <ion-menu-toggle>
                        <ion-item lines="none" button="true" detail="true" [routerLink]="CommonRoute.MY_LISTINGS" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-testid="menu-my-listings">
                            <ion-icon name="people-outline" slot="start"></ion-icon>
                            <ion-label>My listings</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                }
            }
            <ion-menu-toggle>
                <ion-item lines="none" button="true" detail="true" routerLink="/delete-zone" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH">
                    <ion-icon name="warning-outline" slot="start" color="danger"></ion-icon>
                    <ion-label>Delete Zone</ion-label>
                </ion-item>
            </ion-menu-toggle>
        </div>

        <!-- App -->
        <div class="menu-group surface">
            <ion-menu-toggle>
                <ion-item lines="none" button="true" detail="true" routerLink="/settings" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-tour="menu-settings">
                    <ion-icon name="settings-outline" slot="start"></ion-icon>
                    <ion-label>Settings</ion-label>
                </ion-item>
            </ion-menu-toggle>
            @if (isAuthenticated() && supportAvailable()) {
                <ion-menu-toggle *hasAccess="'SupportTicketListComponent'">
                    <ion-item lines="none" button="true" detail="true" [routerLink]="CommonRoute.HELP" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-tour="menu-help">
                        <ion-icon name="chatbubble-ellipses-outline" slot="start"></ion-icon>
                        <ion-label>Help &amp; Support</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            }
            <ion-menu-toggle>
                <ion-item lines="none" button="true" detail="true" routerLink="/about" routerLinkActive="menu-item-active" [routerLinkActiveOptions]="MENU_LINK_MATCH" data-tour="menu-about">
                    <ion-icon name="information-circle-outline" slot="start"></ion-icon>
                    <ion-label>About</ion-label>
                </ion-item>
            </ion-menu-toggle>
            @if (isAuthenticated()) {
                <ion-menu-toggle>
                    <ion-item lines="none" button="true" routerLink="/logout">
                        <ion-icon name="log-out-outline" slot="start"></ion-icon>
                        <ion-label>Sign out</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            }
        </div>
      </div>
    </ion-content>
</ion-menu>
